<template>
  <div class="reports-wrapper">
    <v-container fill-height fluid style="position: absolute" v-if="loader">
      <v-row align="center" justify="center">
        <v-progress-circular
          class="mt-10"
          size="100"
          color="#006CA1"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>
    <div class="px-6 py-8" v-else>
      <v-row no-gutters>
        <v-col cols="12" md="5" lg="5" class="px-md-4">
          <reports-issued-certificates />
        </v-col>
        <v-col cols="12" md="7" lg="7" class="pt-4 pt-md-0">
          <reports-revoked-certificates />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ReportsIssuedCertificates from "@/components/reports/reports-items/reports-issued-certificates.vue";
import moment from "moment/moment";
import ReportsRevokedCertificates from "@/components/reports/reports-items/reports-revoked-certificates.vue";

export default {
  name: "reports-index",
  components: { ReportsRevokedCertificates, ReportsIssuedCertificates },
  methods: {
    ...mapActions(["updateCas"]),
    formatBreakpoint(moment) {
      return moment.utc().format("YYYYMMDDHHmmss[Z]");
    },
  },
  mounted() {
    let issuedArray = [];
    let revokedArray = [];

    // moment.locale('sv');
    issuedArray.push(this.formatBreakpoint(moment.utc().startOf("isoWeek")));
    issuedArray.push(this.formatBreakpoint(moment.utc().endOf("isoWeek")));

    for (let i = 0; i < 8; i++) {
      revokedArray.push(
        this.formatBreakpoint(moment.utc().startOf("isoWeek").add(i, "days"))
      );
    }

    this.updateCas({
      issuedCertsParams: {
        breakpoints: issuedArray.join(","),
      },
      revokedCertsParams: {
        breakpoints: revokedArray.join(","),
      },
    }).then(() => {
      this.loader = false;
    });
  },
  data() {
    return {
      issuedCertificatesTimeRangeModel: "This week",
      issuedCertificatesTimeRangeItems: ["This week", "Last week", "Last 6 months"],
      caModel: "All CAs",
      caItems: ["All CAs", "CA 1", "CA 2"],
      loader: true,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";
@import "~vuetify/src/styles/styles.sass";

// You need to map-merge your new SASS variables
$grid-breakpoints: map-merge(
  $grid-breakpoints,
  (
    xs: 0,
    sm: 476px,
    md: 668px,
    lg: 1600px,
    xl: 2000px,
  )
);

.reports-wrapper {
  width: 100%;
}
</style>
